import { Breadcrumb, BreadcrumbData } from '../../components/Breadcrumbs';

export function AnnotationQueueBulkViewCrumb(props: Partial<BreadcrumbData>) {
  return <Breadcrumb name={'All runs'} {...props} />;
}
